import { render, staticRenderFns } from "./SignUpNeopag.vue?vue&type=template&id=760eaec7&"
import script from "./SignUpNeopag.vue?vue&type=script&lang=js&"
export * from "./SignUpNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports